import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { createSystemRoutes, RoutesBySystem } from '@/router/utils';

import { RMPC_ROUTES } from './config';

const TattooSearch = lazy(() => import('../pages/services/TattooSearch'));

const rmpcSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.RMPC>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  TATTOO_SEARCH: TattooSearch,
};

export const RmpcRouter: RouteObject = createSystemRoutes(IntegrationSystem.RMPC, RMPC_ROUTES, rmpcSystemComponents);
